// extracted by mini-css-extract-plugin
export var closeButton = "_s-5";
export var container = "_s-0";
export var contentContainer = "_s-1";
export var desktop = "_s-2";
export var fullModalImage = "_s-6";
export var mobile = "_s-3";
export var withImage = "_s-4";